/**
 * Hauteur par défaut d'un champ de texte long, en lignes. `rows` plutôt qu'une hauteur en pixels :
 * c'est l'API du `<textarea>`, elle suit la fonte, et elle donne une échelle au lieu d'une valeur
 * magique par appelant.
 */
export const LONG_TEXT_ROWS = 6;

/**
 * Hauteur des deux champs les plus longs du produit — l'expérience pédagogique et la description
 * d'une méthodologie d'enseignement. Nommée parce qu'ils doivent rester d'accord : ils se sont
 * déjà désynchronisés une fois.
 *
 * En pixels, contrairement au défaut ci-dessus : c'est une hauteur demandée comme telle, et ces
 * deux champs la veulent identique au pixel près plutôt qu'à la ligne près.
 */
export const LONG_TEXT_TALL_MIN_HEIGHT = "min-h-[420px]";
